import { supabase } from '../lib/supabase'

/**
 * Connexion par courriel et mot de passe.
 *
 * Le parametre `jetonCaptcha` est prevu mais pas encore utilise : un controle
 * anti-robot (Turnstile) est la vraie reponse a un deni de service sur le
 * formulaire de connexion, et il arrivera dans un lot ulterieur. Il est declare
 * ici pour que son ajout ne demande pas de reecrire la page — seulement de
 * renseigner l'argument.
 */
export async function connecter(
  courriel: string,
  motDePasse: string,
  jetonCaptcha?: string,
): Promise<{ ok: true } | { ok: false }> {
  const { error } = await supabase.auth.signInWithPassword({
    email: courriel,
    password: motDePasse,
    ...(jetonCaptcha === undefined ? {} : { options: { captchaToken: jetonCaptcha } }),
  })

  // On ne rend PAS le message d'erreur du fournisseur. Un courriel inconnu et un
  // mot de passe faux doivent etre indistinguables : autrement, le formulaire
  // devient un moyen de savoir qui possede un compte.
  return error ? { ok: false } : { ok: true }
}

export async function deconnecter(): Promise<void> {
  await supabase.auth.signOut()
}
